import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { genElObject } from "../../../../components/utils/EditorDialogElementGenerator";
import CustomerSelectorMain from "../../../selectors/customer-selector/component/customer-selector-main";
import ProductSelectorMain from "../../../selectors/product-selector/component/product-selector-main";
import { useSelector } from "react-redux";

const PackageRequestFilter = (props) => {
  const { filterValue, setFilterValue, onClickRefresh } = props;
  const employee = useSelector((state) => state.auth.employee);

  const [showCustomerSelector, setShowCustomerSelector] = useState(false);
  const [showProductSelector, setShowProductSelector] = useState(false);

  const handleOnClickCustomer = () => {
    setShowCustomerSelector(true);
   };

  const handleOnConfirmCustomer = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setFilterValue({ ...filterValue, data_customer: selected, customer_id: selected.id });
      setShowCustomerSelector(false);
    }
    return selected;
  };

  const handleOnClickProduct = () => {
    setShowProductSelector(true);
   };

  const handleOnConfirmProduct = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setFilterValue({ ...filterValue, data_product: selected, product_id: selected.id });
      setShowProductSelector(false);
    }
    return selected;
  };

  const elCustomer = genElObject({
    field: 'customer_id',
    name: 'Customer',
    value: filterValue.data_customer ? filterValue.data_customer.name : '',
    onClick: handleOnClickCustomer,
    onClear: () => {
      setFilterValue({ ...filterValue, data_customer: null, customer_id: null });
    },
  });

  const elProduct = genElObject({
    field: 'product_id',
    name: 'Product',
    value: filterValue.data_product ? filterValue.data_product.name : '',
    onClick: handleOnClickProduct,
    onClear: () => {
      setFilterValue({ ...filterValue, data_product: null, product_id: null });
    },
  });

  return (
    <div className="flex flex-col sm:flex-row justify-center items-end gap-4 w-full">
      <CustomerSelectorMain
        title={'Select Customer'}
        visible={showCustomerSelector}
        onHide={() => setShowCustomerSelector(false)}
        onConfirm={handleOnConfirmCustomer}
        additionalFilter={employee?.user_type == 3 ? `bc_id:=:${employee.id}` : ''}
      />

      <ProductSelectorMain
        title={'Select Product'}
        visible={showProductSelector}
        onHide={() => setShowProductSelector(false)}
        onConfirm={handleOnConfirmProduct}
        additionalFilter={``}
      />
      {/* filter component section */}
      <div className="flex flex-col sm:flex-row justify-start items-center gap-4 w-full">
        {elCustomer}
        {elProduct}
      </div>
      {/* refresh section */}
      <Button
        icon="pi pi-refresh"
        outlined
        rounded
        onClick={() => {
          if (onClickRefresh) onClickRefresh();
        }}
      />
    </div>
  );
};

export default PackageRequestFilter;
